import React from 'react';
import { Route } from 'react-router-dom';
import { unitPath, viewPath } from 'shared/routes/building';
import UnitView from './UnitView';
import UnitSearch from './UnitSearch';

/**
 * @param {Object} props
 * @param {Function} props.buildingDispatch
 * @param {Object<string, *>} props.buildingState
 * @param {Function} props.setSubtitle
 */
export default function UnitRouter(props) {
  const {
    buildingState,
    buildingDispatch,
    setSubtitle,
  } = props;

  const { data: { id } } = buildingState;
  return (
    <>
      <Route
        path={`${viewPath}/${id}${unitPath}`}
        exact
        render={() => (
          <UnitSearch
            buildingState={buildingState}
            buildingDispatch={buildingDispatch}
          />
        )}
      />
      <Route
        path={`${viewPath}/${id}${unitPath}/:unitId`}
        render={({ match: { params: { unitId } } }) => (
          <UnitView
            buildingState={buildingState}
            buildingDispatch={buildingDispatch}
            unitId={parseInt(unitId, 10)}
            setSubtitle={setSubtitle}
          />
        )}
      />
    </>
  );
}
